import { render } from "./GenericCard.vue?vue&type=template&id=510962f0&scoped=true"
import script from "./GenericCard.vue?vue&type=script&lang=js"
export * from "./GenericCard.vue?vue&type=script&lang=js"

import "./GenericCard.vue?vue&type=style&index=0&id=510962f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510962f0"]])

export default __exports__